<template>
  <div class="members-status">
    <div class="card">
      <div class="card-body">
        <div class="card" >
          <table class="table">
            <thead>
              <tr>
                <th>プレイヤー名</th>
                <th>お題</th>
                <th>投票</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="member in members" :key="member.uid">
                <td>{{ member.name }}</td>
                <td>{{ isDecidedTheme[member.uid] ? '決定' : '未決定'  }}</td>
                <td>{{ votes.some(vote => vote.from === member.uid) ? '完了' : '未完了' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MembersStatus',
  props: {
    members: Array,
    isDecidedTheme: Object,
    votes: Array
  }
}
</script>
<style scoped>
</style>
